import { toLower } from "lodash"
import { Link } from "react-router-dom"
import { MarkText } from "../../../components/MarkText"
import { JIRA_STATUS } from "../../../settings"
import { formatDate, highlightText, replaceBrackets } from "../../../utils"

export const issues = ({ pathname, search, context, isAdmin, jiraRead, org, orgName }) => ({
    enabled: jiraRead,
    columns: [
        {
            title: "Issue ID",
            dataIndex: "ticketRef",
            width: 100,
            render: (text, record, index) => (
                <MarkText text={highlightText(text, context)} />
            ),
            defaultSortOrder: "desc",
            sorter: (a, b) => { if (a && a.hasOwnProperty("ticketRef") && a.ticketRef) return Number(a.ticketRef.substring(a.ticketRef.lastIndexOf("-") + 1)) - Number(b.ticketRef.substring(b.ticketRef.lastIndexOf("-") + 1)) },
        },
        {
            title: "Summary",
            dataIndex: "summary",
            ellipsis: false,
            render: (text, record, index) => (
                <Link to={{ pathname: `${pathname}/${toLower(record.ticketRef)}`, state: { from: pathname + search }}}>
                    <MarkText title={text} text={highlightText(text, context)} />
                </Link>
            ),
            sorter: (a, b) => { if (a && a.hasOwnProperty("summary") && a.summary) return a.summary.localeCompare(b.summary) }
        },
        {
            title: "Reporter",
            dataIndex: "submittedBy",
            width: 200,
            render: (text, record, index) => (
                <MarkText title={text} text={highlightText(replaceBrackets(text), context)} />
            ),
            sorter: (a, b) => { if (a && a.hasOwnProperty("submittedBy") && a.submittedBy) return a.submittedBy.localeCompare(b.submittedBy) }
        },
        isAdmin && !org ?
        {
            title: "Organization",
            dataIndex: "orgName",
            width: 150,
            ellipsis: true,
            render: (text, record, index) => (
                <MarkText title={text} text={highlightText(replaceBrackets(text), context)} />
            ),
            sorter: (a, b) => { if (a && a.hasOwnProperty("orgName") && a.orgName) return a.orgName.localeCompare(b.orgName) }
        }
        : {},
        {
            title: "Created",
            dataIndex: "submitDatetime",
            width: 100,
            render: (text, record, index) => (
                <MarkText title={text} text={highlightText(formatDate(text, "DD-MM-YYYY"), context)} />
            ),
            sorter: (a, b) => { if (a && a.hasOwnProperty("submitDatetime") && a.submitDatetime) return a.submitDatetime.localeCompare(b.submitDatetime) },
        },
        {
            title: "Status",
            dataIndex: "status",
            width: 150,
            ellipsis: true,
            render: (text, record, index) => (
                <MarkText title={text} text={highlightText(text, context)} />
            ),
            sorter: (a, b) => { if (a && a.hasOwnProperty("status") && a.status) return a.status.localeCompare(b.status) }
        }
    ],
    searchOptions: [
        { key: "status", title: "Status", type: "select", options: JIRA_STATUS, placeholder: "The status of JIRA issue", multiple: true },
    ],
    breadcrumbs: org
        ? [
            { title: orgName, href: "/organisations/" + org },
            { title: "Issues" }
        ]
        : null
})